import { Injectable, Output, EventEmitter } from '@angular/core';


@Injectable()
export class MealOptionService {

  public activeRecipeID: number;

  @Output() activeRecipeIDEvt = new EventEmitter();

  constructor() { }

  updateActiveRecipeID(arid) {
    this.activeRecipeID = arid;
    this.activeRecipeIDEvt.emit(arid);
  }

}
